import { render, staticRenderFns } from "./unBindDialog.vue?vue&type=template&id=81da8550&"
import script from "./unBindDialog.vue?vue&type=script&lang=js&"
export * from "./unBindDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports